import React, { useState, useContext } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { AppLoad } from "../../../core/AppLoad";
import { useHistory } from "react-router-dom";
import { AppStateContext, AppConfig } from "../../../app-state";
import { NavbarBackHome } from "../../common/header-and-footer/NavbarBackHome";
import { FormGroup } from "../../../core/Form";
import { Icon } from "../../../core/Icon";
export const ForgottenPassword = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    const [isLoading, updateLoading] = useState(false);
    const [loginResponse, updateLoginResponse] = useState(null);
    const { register, handleSubmit, errors, setValue } = useForm();
    let history = useHistory();
    const onSubmit = (data) => {
        updateLoading(true);
        AppLoad(AppConfig.APIUrl + 'public/auth/forgotten-password', data).then((Response) => {
            if (Response.status == 'ok') {
                history.push('/cs/proces/heslo-odeslano');
            }
            else if (Response.status == 'error') {
                alert(Response.message);
            }
            updateLoading(false);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NavbarBackHome, null),
        React.createElement("div", { className: "process-master-form" },
            React.createElement("div", { className: "" },
                React.createElement("h1", { className: "page-header" }, "Zapomenut\u00E9 heslo"),
                React.createElement("p", { className: "lead" }, "Z bezpe\u010Dnostn\u00EDch d\u016Fvod\u016F nen\u00ED mo\u017En\u00E9 v\u00E1m va\u0161e zapomenut\u00E9 heslo zaslat, proto\u017Ee v syst\u00E9mu je ulo\u017Eena pouze jeho za\u0161ifrovan\u00E1 podoba."),
                React.createElement("p", null, "Pokud m\u00E1te p\u0159\u00EDstup k emailu uveden\u00E9mu p\u0159i registraci, budou v\u00E1m na n\u011Bj zasl\u00E1ny informace k vyresetov\u00E1n\u00ED hesla."),
                React.createElement("form", { onSubmit: handleSubmit(onSubmit), className: "form" },
                    React.createElement(FormGroup, { id: "email", cssWrapper: "large", label: "Emailov\u00E1 adresa", error: errors.email && 'Prosím vyplňte' },
                        React.createElement("div", { className: "input-with-icon" },
                            React.createElement(Icon, { c: ['mail', 16, 16] }),
                            React.createElement("input", { className: "textfield", id: "email", ref: register({ required: true }), name: "email", type: "text" }))),
                    React.createElement("div", { className: "btn-wrap" },
                        React.createElement("button", { type: "submit", className: classNames("primary-button", { "is-busy": isLoading }) },
                            React.createElement("span", { className: "text" }, "Odeslat"),
                            React.createElement("span", { className: "spinner", "aria-hidden": true }))))))));
};
